import React, { Component } from 'react';
import { fieldSchema } from '../../../common/formElements/CollectionSectionType';
import FieldForm from './FieldForm';
class AddNewField extends Component {
  showCard = () => {
    return {
      display: !this.props.isAddNewField ? 'none' : '',
    };
  };

  handleSubmit = (values) => {
    const { actions, projectId, version, collection } = this.props;
    actions.createNewField({
      projectId: projectId,
      version,
      collectionName: collection.collectionName,
      data: values,
    });
    this.props.closeNewField();
  };

  deleteField = () => {
    this.props.closeNewField();
  };

  render() {
    const {
      collectionOptions,
      projectCollections,
      showCollectionFieldDeleteLoader,
      projectDetail,
      fieldFlag,
    } = this.props;
    return (
      <div style={this.showCard()}>
        <FieldForm
          title="New Field"
          fieldName="New Field"
          type="text"
          createSchemaForFields={fieldSchema}
          collectionOptions={collectionOptions}
          handleSubmit={this.handleSubmit}
          projectCollections={projectCollections}
          deleteField={this.deleteField}
          showCollectionFieldDeleteLoader={showCollectionFieldDeleteLoader}
          projectDetail={projectDetail}
          fieldFlag={fieldFlag}
        />
      </div>
    );
  }
}

export default AddNewField;
